import { render, staticRenderFns } from "./btnlink.vue?vue&type=template&id=15666b37&"
import script from "./btnlink.vue?vue&type=script&lang=js&"
export * from "./btnlink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports